<div>
    <div class="row">
        <div class="col-sm-12">
            <span class="title">
                <fa-icon [icon]="['fas', 'hashtag']" ></fa-icon>
                {{ pad(strJobOrOpportunityNumber, 6) }}
            </span>
            <span class="title" *ngIf="strResponseType === 'main_prompts'">&nbsp;-&nbsp;{{ arChecklist['name'] }}
                <span *ngIf="strResponseType === 'main_prompts' && arChecklist['type'] !== 'asset' && strReviewStatus === 'review_complete'"
                    class="review-completed-by">
                   ( {{ 'reviewed_completed_by' | translate }} {{ arChecklist.review_status_completed_by }} on
                    {{ arChecklist.review_status_completed_date | humanReadableDate | placeholdWithString }} )
                </span>
            </span>

            <span class="buttons d-flex d-flex-gap">
                <fieldmagic-primary-button
                    *ngIf="showChecklistRebuild$ | async"
                    label="Rebuild"
                    icon="wrench"
                    [isInProgress]="rebuilding$ | async"
                    (click)="onRebuild()"
                ></fieldmagic-primary-button>

                <fieldmagic-primary-button
                    *ngIf="! (fetching$ | async) && strResponseType === 'main_prompts' && arChecklist['type'] !== 'asset' && strReviewStatus === 'review_pending'"
                    variant="success"
                    (click)="changeReviewStatusToComplete()"
                    label="mark_completed"
                    icon="book-reader"
                ></fieldmagic-primary-button>

                <fieldmagic-primary-button
                    *ngIf="showDefectDetails$ | async"
                    variant="error"
                    icon="exclamation-circle"
                    label="View Defects"
                    (click)="onViewDefects()"
                    [color]="highestFaultColor$ | async"
                ></fieldmagic-primary-button>

                <fieldmagic-primary-button
                    *ngIf="! (fetching$ | async) && (showCompletionDetails$ | async)"
                    label="View Completion Details"
                    icon="check-circle"
                    variant="success"
                    (click)="onViewCompletionDetails()"
                    [isInProgress]="previewingCompletionDetails$ | async"
                ></fieldmagic-primary-button>

                <fieldmagic-primary-button
                    *ngIf="! (fetching$ | async) && ! (showAssetLists$ | async)"
                    id="btnSave"
                    purpose="save"
                    (click)="onSubmit()"
                    [isInProgress]="saving$ | async"
                ></fieldmagic-primary-button>

                <fieldmagic-primary-button
                    id="btnCancel"
                    (click)="cancelDialog()"
                    icon="times"
                    variant="error"
                    label="close"
                    [disabled]="saving$ | async"
                ></fieldmagic-primary-button>
            </span>
        </div>
    </div>

    <hr class="separator"/>
    <mat-dialog-content>
        <fieldmagic-async-content [loading]="fetching$ | async">
        <ng-template fieldmagicAsyncLoadedContent>
        <div class="containers">
            <div *ngFor="let objPrompt of arPrompts, index as indexPromptTypes">

                <!-- ONLY SHOW PROMPTS THAT ARE RELATIVE TO THE ONE WHO CALLED THIS DIALOG -->
                <!-- (per_asset_prompts if was called in asset widget / main_prompts if called in checklist widget ) -->
                <ng-container *ngIf="objPrompt !== null && isQuestionVisible(objPrompt) && objPrompt['prompts'].length > 0">
                    <ng-container *ngIf="objPrompt['prompts'].length">
                        <ng-container *ngFor="let prompt of objPrompt['prompts'] index as indexPrompts">
                            <div *ngIf="prompt['is_group']" class="row body-container pt-1 pb-2">
                                <div class="col-12 border-light-blue prompt-rows p-0 rounded-top">
                                    <div class="bg-light-blue d-flex justify-content-between p-2">
                                        <div class="d-flex align-items-center">
                                            <span class="fs-14 font-weight-bold text-white">
                                                {{ indexPrompts + 1 }}. {{ prompt['group_name'] | translate }}
                                            </span>
                                        </div>

                                        <div class="d-flex gap-10 align-items-center">
                                            <span
                                                *ngIf="(arChecklist | data_get: 'type') != 'asset' || (prompt | data_get: 'available_period') == 'always'"
                                                class="fa-stack"
                                            >
                                                <fa-icon
                                                    [icon]="['fas', 'circle']"
                                                    class="fa-stack-1x text-white fs-16 ml-1">
                                                </fa-icon>

                                                <fa-icon
                                                    [icon]="['fas', 'plus-circle']"
                                                    class="text-success fa-stack-1x pointer fs-16 ml-1"
                                                    (click)="repeatGroup(prompt, indexPrompts)"
                                                    matTooltip="{{ 'repeat_group' | translate }}">
                                                </fa-icon>
                                            </span>

                                            <fa-icon
                                                *ngIf="hasRepeatingGroup(prompt, indexPrompts)"
                                                [icon]="['fas', 'trash-alt']"
                                                class="text-warning pointer fs-16"
                                                (click)="removeGroup(indexPrompts)"
                                                matTooltip="{{ 'remove_group' | translate }}">
                                            </fa-icon>
                                        </div>
                                    </div>

                                    <div>
                                        <app-checklist-response-prompt
                                            *ngFor="let subprompt of prompt['prompts']; index as i"
                                            class="row body-container w-100 m-0"
                                            [objPrompt]="subprompt"
                                            [numIndex]="i"
                                            [arNumberOfErroneousText]="arNumberOfErroneousText"
                                            [objMetadata]="arMetadata"
                                            [bIsUnderGroup]="true"
                                            [bIsCommentEnabled]="bIsCommentEnabled"
                                            (formDirtyEmitter)="markAsDirty($event)"
                                            (passFailPromptEmitter)="checkForFailedPassFailPrompts()"
                                            [errors]="errors | data_get: subprompt.id"
                                        >
                                        </app-checklist-response-prompt>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!prompt['is_group']" class="prompts-container">
                                <app-checklist-response-prompt
                                    class="row w-100 m-0"
                                    [objPrompt]="prompt"
                                    [numIndex]="indexPrompts"
                                    [arNumberOfErroneousText]="arNumberOfErroneousText"
                                    [objMetadata]="arMetadata"
                                    [bIsCommentEnabled]="bIsCommentEnabled"
                                    (formDirtyEmitter)="markAsDirty($event)"
                                    (passFailPromptEmitter)="checkForFailedPassFailPrompts()"
                                    [errors]="errors | data_get: prompt.id"
                                >
                                </app-checklist-response-prompt>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>

            </div>

            <div
                *ngIf="showFaultDetailsInput$ | async"
                class="row card faults-container"
            >
                <div class="card-header text-center faults-header" >
                    <span class="prompt-required">{{ 'required' | translate }}</span>
                    {{ 'fault_details' | translate }}
                </div>
                <div class="card-body fault-body">
                    <textarea id="textareaFaultDetails" class="form-control fault-details" [(ngModel)]="strFaultDetails" rows="3" (ngModelChange)="markAsDirty()">{{ strFaultDetails }}</textarea>
                </div>
            </div>

            <div
                 *ngIf="showProductsToFix$ | async"
                class="row card products-container"
            >
                <div class="card-header text-center faults-header" >
                    {{ 'products_required_to_fix' | translate }}
                </div>
                <div class="card-body fault-body">
                    <ng-select
                        id="ngSelectProductsRequiredToFix"
                        [items]= "objProducts['obv'] | async"
                        [typeahead]= "objProducts['typehead']"
                        [loading]= "objProducts['loader']"
                        [hideSelected]= "true"
                        [clearable]= "true"
                        [multiple] = "true"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="arProducts"
                        bindLabel="name"
                        bindValue="id"
                        (open)="triggerSubject(objProducts['typehead'])"
                        appendTo="body"
                        (ngModelChange)="markAsDirty()">
                        <!-- DISPLAY IN OPTION -->
                        <ng-template  ng-option-tmp let-item="item" let-index="index">
                            <span id="productsRequiredOption{{index}}" class="value-text"> {{ item.name | translate }} </span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <checklist-responses-assets-list
                *ngIf="showAssetLists$ | async"
                [assets]="assets$ | async"
            ></checklist-responses-assets-list>
        </div>
        </ng-template>
        </fieldmagic-async-content>
    </mat-dialog-content>
</div>
